import React, { Component } from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import { reduxForm, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';

import Core from '../../../models/Core';
import { EDIT_CORE_FORM } from '../../../constants/globals';
import {
  getManufacturers,
  getResinsByManufacturerId,
  getCoreOptionsByResinId,
  getDefaultResinId,
} from '../../../reducers'
import {
  selectOptionPropType,
  materialWithCountPropType
} from '../../../lib/shapes';
import { validate } from '../../../lib/core';

import EditCoreFields from './EditCoreFields';
import EditFormActions from './EditFormActions';
import Warnings from './LayerWarnings';

const formName = EDIT_CORE_FORM; 

export class EditCoreForm extends Component {
  constructor(props) {
    super(props);
    this.initializeForm();
  }

  onSubmit(value) {
    const { onSubmit, handleSubmit } = this.props;
    handleSubmit(onSubmit)(value);
  }

  initializeForm() {
    const { initialize, layer } = this.props;
    const { manufacturerId, name, resinId } = layer;
    initialize({
      name,
      resin: {
        manufacturerId,
        id: resinId,
      }
    });
  }

  render() {
    const {
      defaultResinId,
      manufacturerOptions,
      resinOptions,
      materialOptions,
      nameValue,
      selectedMaterial,
      selectedResinId,
      layer,
      mirror,
      onCancel,
      pristine,
      invalid,
      applyMirror,
      lengthUnit
    } = this.props;

    const selectionChanged = selectedMaterial && selectedMaterial.id !== layer.materialId;
    const nameChanged =  nameValue !== layer.name;
    const canSubmit = !(pristine || invalid) && (selectionChanged || nameChanged || applyMirror);
    const onSubmit = this.onSubmit.bind(this);
    const materials = materialOptions
      .sort((a, b) => a.thickness - b.thickness);

    const { warnings } = validate(selectedMaterial, defaultResinId);

    return (
      <form onSubmit={onSubmit}>
        <EditCoreFields
          layer={layer}
          manufacturerOptions={manufacturerOptions}
          resinOptions={resinOptions}
          materialOptions={materials}
          selectedResinId={selectedResinId}
          selectedMaterial={selectedMaterial}
          lengthUnit={lengthUnit}
        />
        <Warnings texts={warnings} />
        <EditFormActions
          layer={layer}
          mirror={mirror}
          onCancel={onCancel}
          canSubmit={canSubmit}
        />
      </form>
    );
  }
}

const selector = formValueSelector(formName);

function mapStateToProps(state){
  const resin = selector(state, 'resin');
  const selectedManufacturerId = resin ? resin.manufacturerId : undefined;
  const selectedResinId = resin ? resin.id : undefined;
  const selectedMaterial = selector(state, 'material');
  const nameValue = selector(state, 'name');
  const applyMirror = selector(state, 'applyMirror');

  return {
    defaultResinId: getDefaultResinId(state),
    manufacturerOptions: getManufacturers(state),
    resinOptions: getResinsByManufacturerId(state, selectedManufacturerId),
    materialOptions: getCoreOptionsByResinId(state, selectedResinId),
    selectedResinId,
    selectedMaterial,
    nameValue,
    applyMirror,
  };
}

const formConfig = {
  form: formName,
};

EditCoreForm.propTypes = {
  // props from the parent component
  layer:      PropTypes.instanceOf(Core).isRequired,
  mirror:     PropTypes.instanceOf(Core).isRequired,
  onCancel:   PropTypes.func.isRequired,
  onSubmit:   PropTypes.func.isRequired,
  lengthUnit: PropTypes.string.isRequired,

  // redux-form props
  initialize: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,

  // mapStateToProps
  nameValue: PropTypes.string,
  applyMirror: PropTypes.bool,
  defaultResinId: PropTypes.string.isRequired,
  manufacturerOptions: PropTypes
    .arrayOf(PropTypes.shape(selectOptionPropType))
    .isRequired,
  resinOptions: PropTypes
    .arrayOf(PropTypes.shape(selectOptionPropType))
    .isRequired,
  materialOptions: PropTypes
    .arrayOf(PropTypes.shape(materialWithCountPropType))
    .isRequired,
  selectedResinId: PropTypes.string,
  selectedMaterial: PropTypes.shape(materialWithCountPropType)
};

EditCoreForm.defaultProps = {
  applyMirror: false,
  selectedMaterial: undefined,
  selectedResinId: undefined,
  nameValue: undefined
}

export default compose(
  reduxForm(formConfig),
  connect(mapStateToProps)
) (EditCoreForm);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/EditCoreForm.js